import MemberTabBase from "@/views/MGT/member/components/member-tab-base.vue";
import { memberAdd } from "@/service/structure.js";
import { rsa, encrypt } from "@/libs/rsa.js";
export default {
  name: "member-add",
  components: {
    MemberTabBase
  },
  props: {
    value: {
      type: Boolean,
      default() {
        return false;
      }
    },
    node: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      styles: {
        height: "calc(100% - 50px)",
        overflow: "scroll",
        paddingBottom: "40px",
        position: "static"
      },
      loading: false,
      member: {}
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    isMobile() {
      return window.innerWidth < 768;
    }
  },
  watch: {
    value(val) {
      if (val) {
        if (this.node.parentId) {
          this.member = {
            departments: [this.node]
          };
        }
      }
    }
  },
  methods: {
    close() {
      this.visible = false;
    },
    async onSubmit(c = "") {
      let res = await this.$refs["memberTabBaseRef"].validate();
      let form = res.form;
      let passwordValid = res.passwordValid;
      res.validate(async valid => {
        if (valid) {
          let params = {
            ...form
          };
          if (form.interfaceOnly === "T") {
            if (!passwordValid) {
              return;
            }
            params.userEmail = "";
            params.userMobile = "";
            params.password = encrypt(form.password);
          } else {
            params.password = "";
            const {
              userEmail,
              userMobile,
              userCode
            } = form;
            if (!userEmail && !userMobile) {
              // lg: 手机号和邮箱不能同时为空
              this.$Message.error($t("2rqjy7c", "手机号和邮箱不能同时为空"));
              return;
            }
            if (userCode === "ADMIN") {
              // lg: 用户代码不能填写ADMIN
              this.$Message.error($t("2eoz38d", "用户代码不能填写ADMIN"));
              return;
            }
            let resRsa = rsa(form, ["userMobile", "userEmail"]);
            params = {
              ...params,
              ...resRsa
            };
          }
          this.loading = true;
          let {
            data
          } = await memberAdd(params);
          this.loading = false;
          if (data && data.result === 0) {
            this.$emit("onSuccess");
            if (c === "continue") {
              // lg: 保存成功，继续添加
              this.$Message.success($t("urbuwj9", "保存成功，继续添加"));
              res.callback && res.callback();
              this.onContinue();
            } else {
              // lg: 保存成功
              this.$Message.success($t("aghf564", "保存成功"));
              this.close();
              res.callback && res.callback();
            }
          }
        }
      });
    },
    /*
     * 继续添加
     */
    onContinue() {
      this.$refs["memberTabBaseRef"].reset();
    }
  }
};